(function () {
  'use strict';

  angular
      .module('tfc.Help')
      .controller('HelpCtrl', HelpCtrl);

  // @ngInject
  function HelpCtrl(Help, Toast) {
    var vm = this;

    vm.subject = '';
    vm.message = '';

    vm.submit = function () {
      Help.send(vm.subject, vm.message).then(function () {
        Toast.success('help.send.confirmation');
      });
    };
  }

})();
